{
  "timeline": {
    "title": "Your free trial",
    "day0Label": "Today",
    "day0Description": "Trial starts",
    "reminderLabel": "Day {{day}}",
    "reminderDescription": "Reminder email sent",
    "trialEndLabel": "Day {{days}}",
    "trialEndDescription": "Trial ends — add a card to keep using AllDrivers"
  },
  "banner": {
    "honestReminder": "Free trial: {{daysRemaining}} of {{trialDays}} days left",
    "trialEndingSoon": "Your trial ends in {{daysRemaining}} days",
    "trialEndedOwner": "Your trial has ended — add a payment method to continue",
    "trialEndedDriverGrace": "Your company's trial ended. You have {{graceDaysRemaining}} days left — pay for your own license to keep driving"
  },
  "expired": {
    "titleOwner": "Your free trial has ended",
    "titleDriver": "Your company access has ended",
    "bodyOwner": "As promised on the trial timeline, to keep using AllDrivers you need to activate your subscription. Your data is safe.",
    "bodyDriver": "Your company grace period is over. Pay for your own license to keep driving — or talk to your manager.",
    "ctaOwner": "Activate subscription",
    "subscriptionError": "Could not create the subscription.",
    "ctaDriver": "Pay for my license"
  },
  "selfPay": {
    "title": "Pay for your own license",
    "body": "Keep driving with AllDrivers even if your company stops paying — the license is yours, tied to your account.",
    "cardUpfront": "{{days}}-day free trial — card requested now, only charged when the trial ends.",
    "cta": "Activate my license",
    "checkoutError": "Could not start the payment. Please try again.",
    "exitDashboard": "Back to home",
    "exitLogout": "Log out",
    "unknownBody": "We could not confirm your license. Check your connection and try again.",
    "retry": "Try again"
  }
}
